const profiles = {
  'ahmed-ben-salem': {
    fr: {
      court: 'Cour de première instance de Tunis',
      bio: 'Spécialisé en droit et état civil. Plus de 400 dossiers livrés pour l\'étranger.',
    },
    ar: {
      court: 'محكمة الاستئناف بتونس',
      bio: 'متخصص في القانون والحالة المدنية. أكثر من 400 ملف لعملاء في الخارج.',
    },
    en: {
      court: 'Court of First Instance of Tunis',
      bio: 'Specialized in legal and civil status documents. 400+ files delivered abroad.',
    },
  },
  'ines-mrad': {
    fr: {
      court: 'Cour d\'appel de Tunis',
      bio: 'Expert en traduction académique et diplômes pour équivalences à l\'étranger.',
    },
    ar: {
      court: 'محكمة الاستئناف بتونس',
      bio: 'خبيرة في الترجمة الأكاديمية والشهادات للمعادلة في الخارج.',
    },
    en: {
      court: 'Court of Appeal of Tunis',
      bio: 'Expert in academic translation and diplomas for equivalence abroad.',
    },
  },
  'karim-haddad': {
    fr: {
      court: 'Cour de première instance d\'Ariana',
      bio: 'Spécialiste des paires avec l\'italien pour immigration et démarches consulaires.',
    },
    ar: {
      court: 'محكمة الاستئناف بأريانة',
      bio: 'متخصص في الأزواج اللغوية مع الإيطالية للهجرة والإجراءات القنصلية.',
    },
    en: {
      court: 'Court of First Instance of Ariana',
      bio: 'Specialist in Italian language pairs for immigration and consular procedures.',
    },
  },
  'leila-trabelsi': {
    fr: {
      court: 'Cour de première instance de Sfax',
      bio: 'Traduction médicale et académique. Dossiers visa et inscription universitaire.',
    },
    ar: {
      court: 'محكمة الاستئناف بصفاقس',
      bio: 'ترجمة طبية وأكاديمية. ملفات التأشيرة والتسجيل الجامعي.',
    },
    en: {
      court: 'Court of First Instance of Sfax',
      bio: 'Medical and academic translation. Visa and university enrollment files.',
    },
  },
  'youssef-gharbi': {
    fr: {
      court: 'Cour de première instance de Tunis',
      bio: 'Référent actes d\'état civil et casier judiciaire. Délais express disponibles.',
    },
    ar: {
      court: 'محكمة الاستئناف بتونس',
      bio: 'مرجع في وثائق الحالة المدنية والسجل العدلي. مواعيد سريعة متاحة.',
    },
    en: {
      court: 'Court of First Instance of Tunis',
      bio: 'Lead for civil status and criminal record documents. Express turnaround available.',
    },
  },
  'salma-ayari': {
    fr: {
      court: 'Cour de première instance de Bizerte',
      bio: 'Traduction commerciale et statuts d\'entreprise. Accompagnement création de société.',
    },
    ar: {
      court: 'محكمة الاستئناف ببنزرت',
      bio: 'ترجمة تجارية ونظام أساسي للشركات. مرافقة تأسيس الشركات في الخارج.',
    },
    en: {
      court: 'Court of First Instance of Bizerte',
      bio: 'Commercial translation and company statutes. Support for business setup abroad.',
    },
  },
};

const shared = {
  fr: {
    title: 'Notre réseau de traducteurs assermentés',
    subtitle: 'Des professionnels agréés par les tribunaux tunisiens. Tarjemlek assure la mise en relation — les coordonnées des traducteurs ne sont pas publiées pour éviter tout contact direct.',
    anonymousTitle: 'Traducteur assermenté agréé',
    networkDisclaimer: 'Les profils affichés sont anonymisés. Vous pouvez laisser Tarjemlek choisir le traducteur le plus adapté ou sélectionner un profil par spécialité.',
    chooseTranslator: 'Choisir un profil traducteur',
    autoAssign: 'Affectation automatique par Tarjemlek',
    autoAssignHint: 'Nous sélectionnons le traducteur le plus qualifié pour votre paire de langues et type de document.',
    translatorLabel: 'Traducteur',
    years: 'ans d\'expérience',
    orders: 'traductions',
    accreditation: 'N° agrément',
    court: 'Tribunal',
    specialties: 'Spécialités',
    languages: 'Langues',
    rating: 'Note',
    backToList: 'Retour au réseau',
    orderWith: 'Commander avec ce profil',
    noTranslatorForLang: 'Aucun profil pour cette paire — affectation automatique appliquée.',
    specialty: {
      legal: 'Juridique',
      civil: 'État civil',
      academic: 'Académique',
      medical: 'Médical',
      commercial: 'Commercial',
      birth: 'Naissance',
      diploma: 'Diplôme',
      driving: 'Permis',
      contract: 'Contrat',
      judgment: 'Jugement',
    },
  },
  ar: {
    title: 'شبكة مترجمينا المعتمدين',
    subtitle: 'محترفون معتمدون لدى المحاكم التونسية. ترجملك تتولى الربط — لا ننشر بيانات الاتصال لتجنب أي تواصل مباشر.',
    anonymousTitle: 'مترجم معتمد لدى المحاكم',
    networkDisclaimer: 'الملفات المعروضة مجهولة الهوية. يمكنكم ترك الاختيار لترجملك أو اختيار ملف حسب التخصص.',
    chooseTranslator: 'اختر ملف مترجم',
    autoAssign: 'تعيين تلقائي من طرف ترجملك',
    autoAssignHint: 'نختار المترجم الأكثر تأهيلاً لزوج اللغات ونوع الوثيقة.',
    translatorLabel: 'المترجم',
    years: 'سنوات خبرة',
    orders: 'ترجمة',
    accreditation: 'رقم الاعتماد',
    court: 'المحكمة',
    specialties: 'التخصصات',
    languages: 'اللغات',
    rating: 'التقييم',
    backToList: 'العودة إلى الشبكة',
    orderWith: 'اطلب مع هذا الملف',
    noTranslatorForLang: 'لا يوجد ملف لهذا الزوج اللغوي — يُطبَّق التعيين التلقائي.',
    specialty: {
      legal: 'قانوني',
      civil: 'حالة مدنية',
      academic: 'أكاديمي',
      medical: 'طبي',
      commercial: 'تجاري',
      birth: 'ولادة',
      diploma: 'شهادة',
      driving: 'رخصة',
      contract: 'عقد',
      judgment: 'حكم',
    },
  },
  en: {
    title: 'Our sworn translator network',
    subtitle: 'Professionals approved by Tunisian courts. Tarjemlek handles assignment — translator contact details are not published to prevent direct outreach.',
    anonymousTitle: 'Court-approved sworn translator',
    networkDisclaimer: 'Profiles are anonymized. Let Tarjemlek assign the best match or pick a profile by specialty.',
    chooseTranslator: 'Choose a translator profile',
    autoAssign: 'Automatic assignment by Tarjemlek',
    autoAssignHint: 'We select the most qualified translator for your language pair and document type.',
    translatorLabel: 'Translator',
    years: 'years experience',
    orders: 'translations',
    accreditation: 'Accreditation no.',
    court: 'Court',
    specialties: 'Specialties',
    languages: 'Languages',
    rating: 'Rating',
    backToList: 'Back to network',
    orderWith: 'Order with this profile',
    noTranslatorForLang: 'No profile for this language pair — automatic assignment applied.',
    specialty: {
      legal: 'Legal',
      civil: 'Civil status',
      academic: 'Academic',
      medical: 'Medical',
      commercial: 'Commercial',
      birth: 'Birth certificate',
      diploma: 'Diploma',
      driving: 'Driving licence',
      contract: 'Contract',
      judgment: 'Judgment',
    },
  },
};

function buildProfiles(lang) {
  return Object.fromEntries(
    Object.entries(profiles).map(([id, copy]) => [id, copy[lang]]),
  );
}

export const translatorsFr = { ...shared.fr, profiles: buildProfiles('fr') };
export const translatorsAr = { ...shared.ar, profiles: buildProfiles('ar') };
export const translatorsEn = { ...shared.en, profiles: buildProfiles('en') };
